import { useDashboardContext } from '../DashboardContext';
import Integrations from '../Integrations';
import DemoSuggestion from '../DemoSuggestion';

export const IntegrationsList = () => {
    const { currentModule } = useDashboardContext();
    if (!currentModule?.isDisabled) {
        return <Integrations />;
    } else {
        return <DemoSuggestion module={currentModule} />;
    }
};
